module.exports = __webpack_public_path__ + "img/NOVOSIB.14104a6b.png";